import { BASE_URL, MODALITY, TRAINER, VENDOR } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";

export async function getTrainers(params: string = "") {
  const response = await axios.get(BASE_URL + TRAINER + params);
  return response.data;
}

export async function getModalities(params: string = "") {
  const response = await axios.get(BASE_URL + MODALITY + params);
  return response.data;
}

export async function addTrainer(data: FormData) {
  const response = await axios.post(BASE_URL + TRAINER, data);
  return response.data;
}

export async function changeTrainerAttendance(data: any) {
  const response = await axios.post(
    BASE_URL + VENDOR + "/SaveVendorAttendnace",
    data
  );
  return response.data;
}

export async function editTrainer(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + TRAINER + "/" + id, data);
  return response.data;
}

export async function deleteTrainer(id: string) {
  const response = await axios.delete(BASE_URL + TRAINER + "/" + id);
  return response.data;
}

export const TrainerCells: HeadCell[] = [
  {
    id: "Logo",
    numeric: false,
    disablePadding: false,
    label: "T_Logo",
  },
  {
    id: "FirstName",
    numeric: false,
    disablePadding: false,
    label: "T_first_name",
  },
  {
    id: "MiddleName",
    numeric: false,
    disablePadding: false,
    label: "T_middle_name",
  },
  {
    id: "LastName",
    numeric: false,
    disablePadding: false,
    label: "T_last_name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "countryCode",
    numeric: false,
    disablePadding: false,
    label: "T_country",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "T_phone_number",
  },
  {
    id: "Biography",
    numeric: false,
    disablePadding: false,
    label: "T_biography",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

export const EvolutionTrainerCells = (numberDays: number): HeadCell[] => {
  const days = Array.from({ length: numberDays }, (_, i) => i + 1).map(
    (num) => {
      return {
        id: `day-${num}`,
        numeric: false,
        disablePadding: false,
        label: `Day ${num}`,
      };
    }
  );
  return [
    {
      id: "employeeName",
      numeric: false,
      disablePadding: false,
      label: "T_name",
    },
    ...days,
    {
      id: "pretestScore",
      numeric: false,
      disablePadding: false,
      label: "T_pretest",
    },
    {
      id: "posttestScore",
      numeric: false,
      disablePadding: false,
      label: "T_posttest",
    },
    {
      id: "finalScore",
      numeric: false,
      disablePadding: false,
      label: "T_finalscore",
    },
    // {
    //   id: "additional",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "T_additional",
    // },
    {
      id: "note",
      numeric: false,
      disablePadding: false,
      label: "T_note",
    },
  ];
};
